import { useEffect, useState } from 'react';
import { fetchUsers } from '@/api/users';
import type { UserSummary } from '@/api/types';

// orbit MPMemberMenu가 client-side 필터링하던 패턴을 server-side로 옮긴 형태.
// q가 비어 있으면 빈 결과 (PM 검색만 유효).
// mode는 향후 'grant' / 'revoke' 별로 다른 endpoint를 둘 때 사용 예정. 현재는 동일.

export type SuggestionMode = 'grant' | 'revoke';

interface EmailSuggestionState {
  results: UserSummary[];
  loading: boolean;
  error: Error | null;
}

const DEBOUNCE_MS = 180;

export function useEmailSuggestions(
  q: string,
  _mode: SuggestionMode = 'grant',
): EmailSuggestionState {
  const [state, setState] = useState<EmailSuggestionState>({
    results: [],
    loading: false,
    error: null,
  });

  useEffect(() => {
    const trimmed = q.trim();
    if (!trimmed) {
      setState({ results: [], loading: false, error: null });
      return;
    }
    const ctrl = new AbortController();
    const timer = window.setTimeout(() => {
      setState((s) => ({ ...s, loading: true, error: null }));
      fetchUsers({ q: trimmed, limit: 20 }, ctrl.signal)
        .then((res) => {
          setState({ results: res.users, loading: false, error: null });
        })
        .catch((err) => {
          if (err instanceof DOMException && err.name === 'AbortError') return;
          setState({
            results: [],
            loading: false,
            error: err instanceof Error ? err : new Error(String(err)),
          });
        });
    }, DEBOUNCE_MS);
    return () => {
      window.clearTimeout(timer);
      ctrl.abort();
    };
  }, [q]);

  return state;
}
